/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-07-05 09:21:29
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-09-26 10:43:08
 * @FilePath: /vue_huaqiang/src/router/modules/report-management.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {RouteConfig} from "vue-router";
import Layout from "@/layout/index.vue";

const requestQuote: RouteConfig[] = [
    {
        path: "/requestQuote",
        component: Layout,
        redirect: "requestQuote",
        name: "requestQuote",
        meta: {
            title: "requestQuote",
            icon: "el-icon-s-goods",
            alwaysShow: true
        },
        children: [
            {
                // 询价单管理
                path: "/askingForQuotationManagement",
                name: "askingForQuotationManagement",
                component: () =>
                    import("@/views-oms/asking-for-quotation-management/Index.vue"),
                meta: {title: "askingForQuotationManagement"}
            },
            // 询价单详情
            {
                path: "/enquiryQuotationDetails",
                name: "enquiryQuotationDetails",
                component: () =>
                    import("@/views-oms/asking-for-quotation-management/Details.vue"),
                meta: {
                    title: "enquiryQuotationDetails",
                    hidden: true,
                    activeMenu: "/askingForQuotationManagement"
                }
            },
            // 生成PI草稿
            {
                path: "/proformaInvoiceDraft",
                name: "proformaInvoiceDraft",
                component: () =>
                    import("@/views-oms/asking-for-quotation-management/Draft.vue"),
                meta: {
                    title: "proformaInvoiceDraft",
                    hidden: true,
                    activeMenu: "/askingForQuotationManagement"
                }
            },
            {
                path: "/quotationAudit",
                name: "quotationAudit",
                component: () =>
                    import("@/views-oms/sales-order-management/quotation/list.vue"),
                meta: {title: "quotationAudit"}
            },
            {
                path: "/salesOrder",
                name: "salesOrder",
                component: () =>
                    import("@/views-oms/sales-order-management/order/list.vue"),
                meta: {title: "salesOrder"}
            },
            {
                path: "/overOrOweList",
                name: "overOrOweList",
                meta: { title: "overOrOweList", badge: "overOrOweCount" },
                component: () =>
                    import("@/views-oms/sales-order-management/over-or-owe-list/index.vue")
            },
            // PI包装
            {
                path: "/piPackageManagement",
                name: "piPackageManagement",
                component: () =>
                    import("@/views-oms/customer-package-management/piPackageManagement.vue"),
                meta: { title: "piPackageManagement" },
            },
            // 包装PI详情
            {
                path: "/piPackageDetail",
                name: "piPackageDetail",
                component: () =>
                    import("@/views-oms/customer-package-management/piPackageDetail.vue"),
                meta: {
                    title: "piPackageDetail",
                    hidden: true,
                    activeMenu: "/piPackageManagement"
                },
            },
            // 无包装PI详情
            {
                path: "/noPackageDetail",
                name: "noPackageDetail",
                component: () =>
                    import("@/views-oms/customer-package-management/noPackageDetail.vue"),
                meta: {
                    title: "noPackageDetail",
                    hidden: true,
                    activeMenu: "/piPackageManagement"
                }
            },
            {
                path: "/piDeliveryTracking",
                name: "piDeliveryTracking",
                meta: { title: "piDeliveryTracking" },
                component: () =>
                    import("@/views-oms/sales-order-management/delivery-tracking/index.vue")
            },
        ],
    }
];

export default requestQuote;
